import { NgModule } from '@angular/core';
import { NzIconModule, provideNzIcons } from 'ng-zorro-antd/icon';

import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  CommentOutline,
  PictureOutline,
  ScissorOutline,
  StopOutline
} from '@ant-design/icons-angular/icons';

const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  CommentOutline,
  PictureOutline,
  ScissorOutline,
  StopOutline
];

@NgModule({
  imports: [NzIconModule],
  exports: [NzIconModule],
  providers: [
    provideNzIcons(icons)
  ]
})
export class IconsProviderModule {}
